/* =========================================================
   LARABICO – Gustometro · codice v4.8 (template "app")
   Dati: JSON stampato da sections/gustometro.liquid
   Regole: gustometro-spec.md (v6)
   v3.5: attributi d'ordine gustometro_profilo + gustometro_riordino
   v3.6: interruttore decaffeinato · cialde assaggio = confezione più piccola
   v3.7: barra spedizione con soglia primo ordine
   v4.0: nuovo template: mobile a schermo intero, desktop a finestra con pannello scuro,
         risultato su una schermata con pannello "profilo completo", striscia geometrica,
         effetto pulse al tocco. Logica di punteggio, varianti, carrello ed email invariata.
   v4.1: altezza reale visibile su mobile (--lbg-vh, --lbg-k), classi lbg--short / lbg--tiny
   v4.3: schermo intero anche su desktop (stesse dinamiche del mobile: X per uscire, carrello sopra)
   v4.4: scala desktop calcolata sull'altezza della finestra (bordo sabbia più ampio)
   v4.5: bordo, spazio interno e misure massime della finestra regolabili dalla sezione
   v4.8: sicurezza: dataLayer solo con consenso statistiche, indirizzo della X controllato
   v4.7: testo del consenso email aggiornato (solo sezione e CSS)
   v4.6: risultato desktop più grande sulle finestre grandi (--lbg-z) + descrizione della miscela nella colonna scura
   ========================================================= */
(function () {
  'use strict';

  var LS_KEY = 'lb_gustometro_v1';
  var ADVANCE_MS = 420; // tempo tra il tocco (pulse) e la domanda dopo

  /* ---------- utilità ---------- */
  function norm(s) {
    return String(s == null ? '' : s).normalize('NFD').replace(/[̀-ͯ]/g, '')
      .toLowerCase().replace(/[:\s]+/g, ' ').trim();
  }
  function slug(s) {
    return norm(s).replace(/%/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function grams(formato) {
    var m = String(formato || '').split(' - ')[0].replace(/\s+/g, '').toLowerCase().match(/(\d+(?:[.,]\d+)?)(kg|g)\b/);
    if (!m) return 0;
    var n = parseFloat(m[1].replace(',', '.'));
    return Math.round(m[2] === 'kg' ? n * 1000 : n);
  }
  function wLabel(g) { return g >= 1000 ? String(Math.round(g / 100) / 10).replace('.', ',') + ' kg' : g + ' g'; }
  function wTag(g) { return g >= 1000 ? (Math.round(g / 100) / 10) + 'kg' : g + 'g'; }
  function podsCount(title, handle) {
    var before = /(\d+)\s*(pz|pezzi|pcs|cialde)\b/i;
    var after = /\b(pz|pezzi|pcs|cialde)\s*\.?\s*(x|da)?\s*(\d+)/i;
    var srcs = [String(title || ''), String(handle || '').replace(/-/g, ' ')];
    for (var i = 0; i < srcs.length; i++) {
      var m = srcs[i].match(before);
      if (m) return +m[1];
      m = srcs[i].match(after);
      if (m) return +m[3];
    }
    return 0;
  }
  function sq(x) { return x * x; }
  function lsGet() { try { return JSON.parse(localStorage.getItem(LS_KEY) || 'null'); } catch (e) { return null; } }
  function lsSet(v) { try { localStorage.setItem(LS_KEY, JSON.stringify(v)); } catch (e) {} }
  // dataLayer solo se il visitatore ha accettato le statistiche nel banner cookie (Customer Privacy API di Shopify).
  // Shopify.analytics.publish va ai pixel di Shopify, che rispettano già il consenso da soli.
  function analyticsAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') return !!cp.analyticsProcessingAllowed();
    } catch (e) {}
    return false;
  }
  function track(name, data) {
    data = data || {};
    if (analyticsAllowed()) { try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, data)); } catch (e) {} }
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('gustometro:' + name, { detail: data })); } catch (e) {}
  }
  function reduced() { try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; } }
  // effetto pulse: anello dorato che si espande dal punto toccato
  function pulse(el) {
    if (!el || reduced()) return;
    el.classList.remove('lbg-pulse');
    void el.offsetWidth;
    el.classList.add('lbg-pulse');
    el.addEventListener('animationend', function h() { el.classList.remove('lbg-pulse'); el.removeEventListener('animationend', h); });
  }

  /* ---------- icone ---------- */
  var I = {
    beans: '<svg class="lbg-ic" viewBox="0 0 40 40" aria-hidden="true"><ellipse cx="15" cy="17" rx="7" ry="10" transform="rotate(-25 15 17)"/><path d="M11 9c4 4 4 12 8 16"/><ellipse cx="26" cy="24" rx="7" ry="10" transform="rotate(20 26 24)"/><path d="M29 15c-4 5-2 13-6 18"/></svg>',
    moka: '<svg class="lbg-ic" viewBox="0 0 40 40" aria-hidden="true"><path d="M16 5h8l1 3h-10z"/><path d="M13 8h14l-2 11H15z"/><path d="M15 19h10l3 15H12z"/><path d="M27 11h4v7l-4 3"/></svg>',
    espresso: '<svg class="lbg-ic" viewBox="0 0 40 40" aria-hidden="true"><rect x="6" y="6" width="28" height="8" rx="1"/><path d="M8 14v20h24V14"/><path d="M14 18h12v3H14z"/><path d="M20 21v3"/><path d="M15 27h9v3a3 3 0 0 1-3 3h-3a3 3 0 0 1-3-3z"/></svg>',
    filtro: '<svg class="lbg-ic" viewBox="0 0 40 40" aria-hidden="true"><path d="M8 7h24l-8 12h-8z"/><path d="M18 19v3h4v-3"/><path d="M11 24h18l-1 8a4 4 0 0 1-4 3h-8a4 4 0 0 1-4-3z"/></svg>',
    pod: '<svg class="lbg-ic" viewBox="0 0 40 40" aria-hidden="true"><circle cx="20" cy="20" r="14"/><circle cx="20" cy="20" r="9.5" stroke-dasharray="2.2 2.2"/><circle class="f" cx="20" cy="20" r="5"/></svg>',
    cup: '<svg class="lbg-ic" viewBox="0 0 40 40" aria-hidden="true"><path d="M7 15h21v7a9 9 0 0 1-9 9h-3a9 9 0 0 1-9-9z"/><path d="M28 17h2.5a3.5 3.5 0 0 1 0 7H28"/><path d="M14 6c-1.5 2 1.5 3 0 5M20 6c-1.5 2 1.5 3 0 5"/></svg>',
    sugar: '<svg class="lbg-ic" viewBox="0 0 40 40" aria-hidden="true"><path d="M10 14l10-5 10 5v12l-10 5-10-5z"/><path d="M10 14l10 5 10-5M20 19v12"/></svg>',
    milk: '<svg class="lbg-ic" viewBox="0 0 40 40" aria-hidden="true"><path d="M15 5h10v5l4 5v20H11V15l4-5z"/><path d="M11 22c3-2 6 2 9 0s6 2 9 0"/></svg>',
    dark: '<svg class="lbg-ic" viewBox="0 0 40 40" aria-hidden="true"><rect x="10" y="7" width="20" height="26" rx="2"/><path d="M10 15.5h20M10 24h20M20 7v26"/></svg>',
    caramel: '<svg class="lbg-ic" viewBox="0 0 40 40" aria-hidden="true"><path d="M20 7c6 7 9 11.5 9 15.5a9 9 0 0 1-18 0C11 18.5 14 14 20 7z"/><path d="M16 23a4 4 0 0 0 4 4"/></svg>',
    berry: '<svg class="lbg-ic" viewBox="0 0 40 40" aria-hidden="true"><circle cx="14" cy="26" r="6"/><circle cx="27" cy="27" r="5.5"/><path d="M14 20c2-6 6-10 10-12M27 21.5c-1-6-2-10-3-13.5"/><path d="M24 8c3-2 6-1 8 1-3 1-5 1-8-1z"/></svg>',
    roast: '<svg class="lbg-ic" viewBox="0 0 40 40" aria-hidden="true"><path d="M20 5c5 5 8 10 8 15a8 8 0 0 1-16 0c0-3.5 1.7-6 3.5-7.7.5 2.7 1.7 4.2 3.5 5 0-5 .5-8.5 1-12.3z"/></svg>',
    nut: '<svg class="lbg-ic" viewBox="0 0 40 40" aria-hidden="true"><path d="M20 9c7 0 11 5 11 12s-5 12-11 12S9 28 9 21 13 9 20 9z"/><path d="M13 14c4 2 10 2 14 0"/><path d="M20 5v4"/></svg>',
    flower: '<svg class="lbg-ic" viewBox="0 0 40 40" aria-hidden="true"><circle cx="20" cy="17" r="3.5"/><path d="M20 13.5c-2-5 2-8 0-8s2 3 0 8zM23.5 17c5-2 8 2 8 0s-3 2-8 0zM16.5 17c-5-2-8 2-8 0s3 2 8 0zM20 20.5c-2 5 2 8 0 8s2-3 0-8z"/><path d="M20 28v7M20 32c-3-2-5-1-6 0"/></svg>',
    lvl1: '<svg class="lbg-ic" viewBox="0 0 40 40" aria-hidden="true"><rect class="f" x="8" y="24" width="6" height="8" rx="1.5"/><rect x="17" y="17" width="6" height="15" rx="1.5"/><rect x="26" y="10" width="6" height="22" rx="1.5"/></svg>',
    lvl2: '<svg class="lbg-ic" viewBox="0 0 40 40" aria-hidden="true"><rect class="f" x="8" y="24" width="6" height="8" rx="1.5"/><rect class="f" x="17" y="17" width="6" height="15" rx="1.5"/><rect x="26" y="10" width="6" height="22" rx="1.5"/></svg>',
    lvl3: '<svg class="lbg-ic" viewBox="0 0 40 40" aria-hidden="true"><rect class="f" x="8" y="24" width="6" height="8" rx="1.5"/><rect class="f" x="17" y="17" width="6" height="15" rx="1.5"/><rect class="f" x="26" y="10" width="6" height="22" rx="1.5"/></svg>',
    bag: '<svg class="lbg-ic lbg-ic--solid" viewBox="0 0 40 40" aria-hidden="true"><rect x="15.2" y="6.6" width="9.6" height="2.6" rx=".7"/><path fill-rule="evenodd" d="M15 10.2h10l1.5 16.8a2 2 0 0 1-2 2.2h-9a2 2 0 0 1-2-2.2z M16.6 17.2h6.8v4.6h-6.8z M20 12.3a1.1 1.1 0 1 0 0 2.2a1.1 1.1 0 1 0 0-2.2z"/></svg>',
    moon: '<svg class="lbg-ic" viewBox="0 0 40 40" aria-hidden="true"><path d="M26 8a13 13 0 1 0 6 21A11 11 0 0 1 26 8z"/></svg>',
    cups: function (n) {
      var offs = n === 1 ? [13] : n === 2 ? [6, 21] : [3, 15, 27];
      return '<svg class="lbg-ic" viewBox="0 0 40 40" aria-hidden="true">' + offs.map(function (o) {
        return '<path d="M' + o + ' 17h9v5a4.5 4.5 0 0 1-4.5 4.5h0A4.5 4.5 0 0 1 ' + o + ' 22z"/>';
      }).join('') + '<path d="M' + (n === 3 ? 3 : 6) + ' 31h' + (n === 3 ? 33 : 28) + '"/></svg>';
    },
    check: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12l5 5 9-10"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    back: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>',
    next: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>',
    close: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    restart: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12a8 8 0 1 0 2.4-5.7"/><path d="M4 4v4.5h4.5"/></svg>',
    cart: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2 3h2.5l2.4 11.2a1.5 1.5 0 0 0 1.5 1.2h9.1a1.5 1.5 0 0 0 1.5-1.1L21 7H5.4"/><circle cx="9" cy="19.5" r="1.4"/><circle cx="17" cy="19.5" r="1.4"/></svg>',
    bell: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 16V11a6 6 0 0 1 12 0v5l1.5 2h-15z"/><path d="M10 20a2 2 0 0 0 4 0"/></svg>',
    clock: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/></svg>',
    chat: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 6.5h16v9H9l-5 3.5z"/></svg>',
    pct: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 18L18 6"/><circle cx="7.5" cy="7.5" r="2.5"/><circle cx="16.5" cy="16.5" r="2.5"/></svg>',
    truck: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2.5 6.5h11v9h-11zM13.5 9.5h4l3 3v3h-7"/><circle cx="6.5" cy="17" r="1.7"/><circle cx="16.5" cy="17" r="1.7"/></svg>'
  };

  /* ---------- striscia geometrica (moduli della confezione) ---------- */
  var STRIP_W = '#EFE9E2', STRIP_O = '#E3891A', STRIP_Y = '#EFB30C', STRIP_D = '#1B120C';
  var TILE = {
    A: '<polygon points="0,0 100,0 50,50" fill="' + STRIP_W + '"/><path d="M0 100A50 50 0 0 1 100 100Z" fill="' + STRIP_O + '"/>',
    B: '<rect width="100" height="100" fill="' + STRIP_W + '"/><circle cx="50" cy="50" r="50" fill="' + STRIP_D + '"/><circle cx="50" cy="58" r="30" fill="' + STRIP_O + '"/><circle cx="50" cy="41" r="16" fill="' + STRIP_D + '"/>',
    C: '<polygon points="0,0 100,0 50,50" fill="' + STRIP_O + '"/><path d="M0 100A50 50 0 0 1 100 100Z" fill="' + STRIP_W + '"/>',
    D: '<path d="M8 8H92V92H72V28H8Z" fill="' + STRIP_Y + '"/><rect x="18" y="44" width="34" height="34" fill="' + STRIP_W + '"/>',
    E: '<path d="M6 44A44 44 0 0 1 94 44Z" fill="' + STRIP_O + '"/><path d="M60 50A25 25 0 0 0 60 100V88A13 13 0 0 1 60 62Z" fill="' + STRIP_O + '"/>',
    F: '<polygon points="0,0 100,0 50,50" fill="' + STRIP_W + '"/><polygon points="0,100 100,100 50,50" fill="' + STRIP_Y + '"/>'
  };
  var SEQ = ['A', 'B', 'C', 'D', 'E', 'F'];
  function strip(n, cls) {
    var g = '';
    for (var i = 0; i < n; i++) g += '<g transform="translate(' + (i * 100 + 3) + ' 3) scale(0.94)">' + TILE[SEQ[i % 6]] + '</g>';
    return '<svg class="lbg-strip ' + (cls || '') + '" viewBox="0 0 ' + (n * 100) + ' 100" preserveAspectRatio="xMinYMin slice" aria-hidden="true" focusable="false"><rect width="' + (n * 100) + '" height="100" fill="' + STRIP_D + '"/>' + g + '</svg>';
  }

  /* ---------- domande (spec) ---------- */
  var VEC = { E: { c: 4, d: 5, a: 3 }, M: { c: 4, d: 4, a: 2 }, S: { c: 5, d: 3, a: 1 } };

  var GRINDS = [
    { l: 'Moka', k: 'moka', chip: 'Moka', i: I.moka },
    { l: 'Espresso', s: 'Macchina manuale', k: 'espresso', chip: 'Espresso', i: I.espresso },
    { l: 'Filtro', s: 'V60, Chemex, americana', k: 'filtro', chip: 'Filtro', i: I.filtro },
    { l: 'In chicchi', s: 'Superautomatica o macinacaffè', k: 'in-grani', chip: 'In Grani', i: I.beans },
    { l: 'Cialde', s: 'Carta ESE 44 mm', k: 'cialde', chip: 'Cialde', i: I.pod }
  ];
  var CONSUMO = [
    { l: '1-2', s: 'caffè al giorno', k: '1-2', i: I.cups(1), g: 1000, cpd: 1.5, q: 1 },
    { l: '3-4', s: 'caffè al giorno', k: '3-4', i: I.cups(2), g: 2000, cpd: 3.5, q: 2 },
    { l: '5 o più', s: 'caffè al giorno', k: '5-piu', i: I.cups(3), g: 4000, cpd: 6, q: 3 },
    { l: 'Prima voglio assaggiarlo', s: 'formato assaggio', k: 'assaggio', i: I.bag, g: 250, cpd: 0, q: 1, dark: true }
  ];
  // lay: list = righe compatte (5 risposte) · list-lg = righe grandi (3 risposte) · grid = griglia 2x2
  var Q = [
    { k: 'metodo', step: 'Metodo', t: 'Come prepari il caffè a casa?', h: 'Così scegliamo la macinatura giusta.', lay: 'list', o: GRINDS },
    { k: 'bevi', step: 'Come lo bevi', t: 'Come lo bevi di solito?', h: "Non c'è una risposta giusta: conta solo il tuo gusto.", lay: 'list-lg', o: [
      { l: 'Amaro', s: 'Puro, senza niente', i: I.cup, v: 'E' },
      { l: 'Con zucchero', s: 'Un cucchiaino', i: I.sugar, v: 'M' },
      { l: 'Con latte', s: 'Macchiato o cappuccino', i: I.milk, v: 'S' }] },
    { k: 'dolce', step: 'Davanti a un dolce', t: 'Davanti a un dolce, cosa scegli?', h: 'I gusti che ami a tavola dicono molto del caffè che fa per te.', lay: 'list-lg', o: [
      { l: 'Frutti rossi e agrumi', i: I.berry, v: 'E' },
      { l: 'Caramello e cioccolato al latte', i: I.caramel, v: 'M' },
      { l: 'Cioccolato fondente', i: I.dark, v: 'S' }] },
    { k: 'profumo', step: 'Profumo', t: 'Quale profumo ti conquista?', h: "Pensa all'aroma che senti quando apri il barattolo.", lay: 'list-lg', o: [
      { l: 'Fiori e frutta', i: I.flower, v: 'E' },
      { l: 'Nocciola e caramello', i: I.nut, v: 'M' },
      { l: 'Tostato e cacao', i: I.roast, v: 'S' }] },
    { k: 'intensita', step: 'Intensità', t: 'Il tuo caffè ideale è…', h: 'Più delicato o più deciso?', lay: 'list-lg', o: [
      { l: 'Morbido', s: 'Rotondo, si beve facile', i: I.lvl1, v: 'E' },
      { l: 'Equilibrato', s: 'Né troppo, né troppo poco', i: I.lvl2, v: 'M' },
      { l: 'Deciso', s: 'Corposo, si fa sentire', i: I.lvl3, v: 'S' }] },
    { k: 'quanti', step: 'Quanti caffè al giorno', t: 'Quanti caffè al giorno, in casa?', h: 'Ti suggeriamo il formato più conveniente.', lay: 'grid', o: CONSUMO }
  ];

  /* ---------- dati prodotto ---------- */
  function optIndex(options, names) {
    for (var i = 0; i < (options || []).length; i++) {
      var n = norm(options[i]).replace(/\s/g, '');
      for (var j = 0; j < names.length; j++) if (n.indexOf(names[j]) === 0) return i;
    }
    return -1;
  }
  function prepProduct(P) {
    if (!P) return null;
    var fi = optIndex(P.options, ['formato']);
    var mi = optIndex(P.options, ['macinatura']);
    return {
      handle: P.handle, title: P.title, url: P.url, img: P.img,
      hasOpts: fi > -1 && mi > -1,
      variants: (P.variants || []).map(function (v) {
        var f = fi > -1 ? v.o[fi] : '';
        return { id: v.id, a: !!v.a, p: v.p, f: f, g: grams(f), m: mi > -1 ? slug(v.o[mi]) : '' };
      })
    };
  }
  function parseValues(raw) {
    if (!raw) return null;
    var out = {};
    var list = Array.isArray(raw) ? raw : Object.keys(raw).map(function (k) { return { name: k, value: raw[k] }; });
    list.forEach(function (it) {
      if (!it) return;
      var n = norm(it.name).replace(/\s/g, '');
      var v = parseFloat(it.value);
      if (isNaN(v)) return;
      if (n === 'corpo') out.c = v;
      else if (n === 'dolcezza') out.d = v;
      else if (n === 'acidita') out.a = v;
      else if (n === 'persistenza') out.p = v;
    });
    return (out.c != null && out.d != null && out.a != null) ? out : null;
  }
  function shortName(title) {
    var t = String(title || '')
      .replace(/^\s*larabico\s*[-–—:]?\s*/i, '')
      .replace(/\s*[-–—]?\s*(da\s*)?1\s*kg\s*$/i, '')
      .trim();
    return t.split(/\s+[-–—]\s+/)[0].trim() || String(title || '').trim();
  }
  function prepPods(list) {
    return (list || []).filter(Boolean).map(function (x) {
      var v0 = (x.variants || [])[0];
      return v0 ? { handle: x.handle, url: x.url, title: x.title, img: x.img, pz: podsCount(x.title, x.handle), id: v0.id, a: !!v0.a, p: v0.p } : null;
    }).filter(function (x) { return x && x.pz; }).sort(function (a, b) { return a.pz - b.pz; });
  }
  function makeBlend(P, v, extra, idx) {
    var sn = shortName(P.title);
    return Object.assign({
      idx: idx, p: P, v: v, sub: '', short: sn, slug: slug(sn), name: 'LARABICO ' + sn,
      taste: null, podsType: null, podsRaw: [], pods: [], idc: [], decaf: null, isDecaf: false
    }, extra || {});
  }
  function prepBlends(raw, report) {
    var out = [];
    (raw || []).forEach(function (r, idx) {
      var P = prepProduct(r.p);
      var title = r.p ? r.p.title : '(prodotto vuoto)';
      var v = parseValues(r.values);
      var row = { title: title, ok: false, why: '' };
      report.push(row);
      if (!P) { row.why = 'prodotto non leggibile'; return; }
      if (!v) { row.why = 'coffee_values assente o senza Corpo/Dolcezza/Acidità'; return; }
      if (!P.hasOpts) { row.why = 'opzioni "Formato" e "Macinatura" non trovate'; return; }
      var b = makeBlend(P, v, {
        sub: r.sub || '', desc: r.desc || '', taste: prepProduct(r.taste), podsType: r.podsType || null,
        podsRaw: r.pods || [], pods: prepPods(r.pods), idc: r.idc || []
      }, idx);
      row.decafWhy = '';
      if (r.decaf) {
        var DP = prepProduct(r.decaf);
        var dv = parseValues(r.decafValues) || v;
        if (!DP || !DP.hasOpts) row.decafWhy = 'prodotto decaffeinato senza opzioni "Formato" e "Macinatura"';
        else b.decaf = makeBlend(DP, dv, { sub: r.decafSub || '', desc: r.decafDesc || '', taste: prepProduct(r.decafTaste), isDecaf: true, base: b, ownValues: !!parseValues(r.decafValues) }, 1000 + idx);
      }
      row.ok = true; row.b = b;
      out.push(b);
    });
    return out;
  }

  /* ---------- punteggio ---------- */
  function answerVecs(ans) { return [1, 2, 3, 4].map(function (qi) { return VEC[Q[qi].o[ans[qi]].v]; }); }
  function score(b, ans) {
    var rs = answerVecs(ans);
    var s = rs.map(function (r) { return 1 / (1 + sq(r.c - b.v.c) + sq(r.d - b.v.d) + sq(r.a - b.v.a)); });
    var m = (s[0] + s[1] + s[2] + s[3]) / 4;
    return { b: b, m: m, s5: s[3], pct: Math.max(50, Math.min(99, Math.round(50 + 49 * m))) };
  }
  function rank(blends, ans) {
    return blends.map(function (b) { return score(b, ans); }).sort(function (x, y) {
      if (Math.abs(x.m - y.m) >= 1e-6) return y.m - x.m;
      if (Math.abs(x.s5 - y.s5) >= 1e-6) return y.s5 - x.s5;
      return x.b.idx - y.b.idx;
    });
  }
  function userProfile(ans) {
    var rs = answerVecs(ans), u = { c: 0, d: 0, a: 0 };
    rs.forEach(function (r) { u.c += r.c / 4; u.d += r.d / 4; u.a += r.a / 4; });
    return u;
  }

  /* ---------- scelta variante ---------- */
  function nearest(list, target) {
    return list.slice().sort(function (x, y) {
      var dx = Math.abs(x.g - target), dy = Math.abs(y.g - target);
      return dx !== dy ? dx - dy : y.g - x.g;
    })[0];
  }
  function pick(b, G, C) {
    if (G.k === 'cialde') {
      if (!b.pods.length) return { soldout: true };
      var small = b.pods[0], big = b.pods[b.pods.length - 1];
      var want = C.k === 'assaggio' ? small : big;
      var qty = C.k === 'assaggio' ? 1 : C.q;
      if (want.a) return { pod: want, qty: qty, id: want.id, price: want.p, url: want.url };
      var other = b.pods.filter(function (x) { return x.a; }).sort(function (x, y) { return Math.abs(x.pz - want.pz) - Math.abs(y.pz - want.pz); })[0];
      if (!other) return { soldout: true };
      return { pod: other, qty: 1, id: other.id, price: other.p, url: other.url,
        note: 'La confezione da ' + want.pz + ' cialde non è disponibile, ti proponiamo ' + other.pz + ' cialde.' };
    }
    var note = '';
    var target = C.g;
    if (C.k === 'assaggio') {
      if (b.taste && b.taste.hasOpts) {
        var t = b.taste.variants.filter(function (v) { return v.a && v.m === G.k && v.g === 250; })[0];
        if (t) return { v: t, qty: 1, id: t.id, price: t.p, url: b.taste.url, g: 250 };
      }
      note = 'Questa miscela non ha il formato da 250 g: ti proponiamo 1 kg.';
      target = 1000;
    }
    var avail = b.p.variants.filter(function (v) { return v.a && v.m === G.k && v.g > 0; });
    if (!avail.length) return { soldout: true };
    var best = nearest(avail, target);
    if (!note && best.g !== target) note = 'Il formato da ' + wLabel(target) + ' non è disponibile, ti proponiamo ' + wLabel(best.g) + '.';
    return { v: best, qty: 1, id: best.id, price: best.p, url: b.p.url, g: best.g, note: note };
  }

  // testo "perché": versione breve per la card, chiusura fissa nel profilo completo
  function whyBits(b) {
    var v = b.v, bits = [];
    if (v.c >= 5) bits.push('ami un caffè corposo e deciso');
    if (v.d >= 5) bits.push('cerchi una dolcezza naturale, anche senza zucchero');
    if (v.a >= 3) bits.push('non ti dispiace una nota fruttata e vivace');
    if (v.a <= 1) bits.push('preferisci poca acidità, note di cacao e tostato');
    if (v.c === 4 && v.d === 4) bits.push("ti piace l'equilibrio tra corpo e dolcezza");
    return bits.slice(0, 2);
  }
  function whyShort(b) {
    var bits = whyBits(b);
    if (!bits.length) return 'Hai un gusto preciso e questa miscela ci si avvicina più di tutte.';
    var s = bits.join(' e ') + '.';
    return s.charAt(0).toUpperCase() + s.slice(1);
  }
  var WHY_CLOSE = 'Tutte le nostre miscele hanno un finale lungo: questa è quella che ti somiglia di più.';

  /* ---------- componente ---------- */
  function Gustometro(root) {
    var D;
    try { D = JSON.parse(root.querySelector('[data-lbg-data]').textContent); } catch (e) { return; }
    var app = root.querySelector('[data-lbg-app]');
    var diag = root.querySelector('[data-lbg-diag]');
    var mail = root.querySelector('[data-lbg-mail]');
    var report = [];
    var blends = prepBlends(D.blends, report);
    var T = D.texts || {};
    var step = -1;
    var ans = [null, null, null, null, null, null];
    var decafOn = false;
    var cur = null;
    var busy = false;

    // schermo intero su mobile (non nell'editor del tema, così le altre sezioni restano visibili)
    if (!D.design) { root.classList.add('lbg--app'); document.documentElement.classList.add('lbg-locked'); fitViewport(); }

    // v4.1: altezza reale visibile (barre del browser, browser di Instagram/Facebook)
    // --lbg-vh = altezza visibile · --lbg-k = scala delle misure (844 px del progetto = 1)
    function fitViewport() {
      var raf = 0, lastW = 0;
      function measure() {
        raf = 0;
        var a = document.activeElement;
        var typing = a && (a.tagName === 'INPUT' || a.tagName === 'TEXTAREA') && root.contains(a);
        var vv = window.visualViewport;
        var h = Math.round(Math.min(window.innerHeight, vv ? vv.height + vv.offsetTop : window.innerHeight));
        var w = window.innerWidth;
        // con la tastiera aperta non ricalcolo la scala (eviterebbe salti mentre si scrive l'email)
        if (typing && w === lastW) return;
        lastW = w;
        // mobile: 844 px = 100% · desktop: finestra (altezza meno il bordo sabbia, max 940) con 760 px = 100%
        var k;
        if (w >= 750) {
          // bordo e altezza massima letti dal CSS (impostazioni della sezione)
          root.style.setProperty('--lbg-vh', h + 'px');
          var padY = parseFloat(getComputedStyle(root).paddingTop) || 0;
          var maxH = parseFloat(getComputedStyle(app).maxHeight) || 940;
          k = Math.max(0.6, Math.min(1, Math.min(maxH, h - 2 * padY) / 760));
        } else {
          k = Math.max(0.6, Math.min(1, h / 844));
        }
        root.style.setProperty('--lbg-vh', h + 'px');
        root.style.setProperty('--lbg-k', k.toFixed(3));
        // desktop: ingrandimento del risultato sulle finestre grandi (1160×760 = 1, max 1,4)
        if (w >= 750) {
          var ar = app.getBoundingClientRect();
          var z = Math.max(1, Math.min(1.4, ar.width / 1160, ar.height / 760));
          root.style.setProperty('--lbg-z', z.toFixed(3));
          if (typeof fitDesc === 'function') fitDesc();
        }
        root.classList.toggle('lbg--short', h < 660);
        root.classList.toggle('lbg--tiny', h < 590);
      }
      function queue() { if (!raf) raf = requestAnimationFrame(measure); }
      measure();
      window.addEventListener('resize', queue);
      window.addEventListener('orientationchange', function () { setTimeout(measure, 250); });
      if (window.visualViewport) window.visualViewport.addEventListener('resize', queue);
      window.addEventListener('pageshow', queue);
    }

    function money(c) {
      try { return new Intl.NumberFormat('it-IT', { style: 'currency', currency: D.currency || 'EUR' }).format(c / 100); }
      catch (e) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
    }
    function focusHeading() {
      var h = app.querySelector('[data-lbg-focus]');
      if (h) { try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); } }
    }
    function saveState() { lsSet({ a: ans.slice(), d: decafOn, t: Date.now() }); }
    function paint(html) {
      app.innerHTML = html;
      if (diag) diag.innerHTML = diagnostics();
      var sc = app.querySelector('.lbg-scroll');
      if (sc) sc.scrollTop = 0;
      if (!D.design && !root.classList.contains('lbg--app') && window.innerWidth >= 750) {
        var r = root.getBoundingClientRect();
        if (r.top < 0) root.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
      }
    }
    function logo() {
      return D.logo
        ? '<img class="lbg-logo' + (D.logoLight ? ' lbg-logo--light' : '') + '" src="' + esc(D.logo) + '" alt="' + esc(D.shopName || 'LARABICO') + '" width="' + (D.logoW || 160) + '" height="' + (D.logoH || 40) + '">'
        : '<span class="lbg-wordmark">LARABICO</span>';
    }
    function title(tag, cls, focus) {
      var lines = (T.heading || []).filter(Boolean);
      if (!lines.length) lines = ['Trova il caffè', 'LARABICO', 'fatto per te'];
      return '<' + tag + ' class="' + cls + '"' + (focus ? ' tabindex="-1" data-lbg-focus' : '') + '>' + lines.map(function (l, i) {
        return '<span' + (i === 1 ? ' class="lbg-gold-t"' : '') + '>' + esc(l) + '</span>';
      }).join('') + '</' + tag + '>';
    }
    function shipLine() {
      if (!D.threshold) return '';
      return '<div class="lbg-shipnote">' + I.truck + '<span>' + (D.firstOrder ? 'Primo ordine: spedizione gratuita da ' : 'Spedizione gratuita da ') + esc(money(D.threshold)) + '</span></div>';
    }
    function exitBtn(cls) {
      // solo indirizzi del sito o http(s): niente javascript: o simili
      var ex = String(D.exitUrl || '/');
      if (!/^(https?:\/\/|\/)/i.test(ex) || /^\/\//.test(ex)) ex = '/';
      return '<a class="lbg-round ' + (cls || '') + '" href="' + esc(ex) + '" aria-label="Esci dal test">' + I.close + '</a>';
    }

    /* ----- intro ----- */
    function intro() {
      var saved = lsGet();
      var canResume = saved && validAns(saved.a);
      paint(
        '<section class="lbg-screen lbg-intro lbg-enter">' + strip(14, 'lbg-strip--wide') +
        '<div class="lbg-intro__top">' + logo() + exitBtn('lbg-round--dark') + '</div>' +
        '<div class="lbg-intro__body">' +
          '<div class="lbg-intro__head">' +
            '<span class="lbg-eyebrow">' + esc(T.eyebrow || 'Gustometro') + '</span>' +
            title('h2', 'lbg-intro__title', true) +
            (T.intro ? '<p class="lbg-intro__text">' + esc(T.intro) + '</p>' : '') +
          '</div>' +
          '<div class="lbg-intro__side">' +
            '<ul class="lbg-benefits">' + [[I.clock, T.bullets && T.bullets[0]], [I.chat, T.bullets && T.bullets[1]], [I.pct, T.bullets && T.bullets[2]]]
              .filter(function (x) { return x[1]; }).map(function (x) { return '<li><span class="lbg-benefits__ic">' + x[0] + '</span>' + esc(x[1]) + '</li>'; }).join('') + '</ul>' +
            '<div class="lbg-intro__cta">' + shipLine() +
              '<button type="button" class="lbg-gold" data-lbg-go>' + esc(T.cta || 'Inizia il test') + I.arrow + '</button>' +
              (canResume ? '<button type="button" class="lbg-link" data-lbg-resume>Riprendi il tuo risultato</button>' : '') +
            '</div>' +
          '</div>' +
        '</div></section>'
      );
      var go = app.querySelector('[data-lbg-go]');
      go.onclick = function () {
        if (busy) return; busy = true;
        pulse(go);
        ans = [null, null, null, null, null, null];
        decafOn = false;
        track('gustometro_start', {});
        setTimeout(function () { busy = false; step = 0; render(true); }, reduced() ? 0 : 260);
      };
      var rb = app.querySelector('[data-lbg-resume]');
      if (rb) rb.onclick = function () { ans = saved.a.slice(); decafOn = !!saved.d; showResult(true); };
    }

    function validAns(a) {
      if (!Array.isArray(a) || a.length !== Q.length) return false;
      for (var i = 0; i < Q.length; i++) if (typeof a[i] !== 'number' || !Q[i].o[a[i]]) return false;
      return true;
    }

    /* ----- pannello laterale desktop delle domande ----- */
    function stepper() {
      return '<ol class="lbg-steps">' + Q.map(function (q, i) {
        var done = ans[i] != null && i < step, now = i === step;
        var lab = done ? q.step + ': ' + q.o[ans[i]].l : q.step;
        return '<li class="' + (done ? 'is-done' : now ? 'is-now' : '') + '"' + (now ? ' aria-current="step"' : '') + '>' +
          '<span class="lbg-steps__n">' + (done ? I.check : (i + 1)) + '</span><span class="lbg-steps__l">' + esc(lab) + '</span></li>';
      }).join('') + '</ol>';
    }

    /* ----- domande ----- */
    function render(focus) {
      if (step < 0) { intro(); if (focus) focusHeading(); return; }
      if (step >= Q.length) { showResult(true); return; }
      var q = Q[step];
      var segs = Q.map(function (_, i) { return '<i class="' + (i <= step ? 'is-on' : '') + '"></i>'; }).join('');
      var opts = q.o.map(function (o, i) {
        var sel = ans[step] === i;
        if (q.lay === 'grid') {
          return '<button type="button" class="lbg-tile' + (o.dark ? ' lbg-tile--dark' : '') + '" data-i="' + i + '" aria-pressed="' + sel + '">' + o.i +
            '<span class="lbg-tile__t"><b>' + esc(o.l) + '</b><small>' + esc(o.s) + '</small></span><span class="lbg-tick" aria-hidden="true">' + I.check + '</span></button>';
        }
        return '<button type="button" class="lbg-opt" data-i="' + i + '" aria-pressed="' + sel + '"><span class="lbg-opt__ic">' + o.i + '</span>' +
          '<span class="lbg-opt__t"><b>' + esc(o.l) + '</b>' + (o.s ? '<small>' + esc(o.s) + '</small>' : '') + '</span><span class="lbg-radio" aria-hidden="true">' + I.check + '</span></button>';
      }).join('');
      paint(
        '<section class="lbg-screen lbg-quiz">' +
          '<aside class="lbg-side">' + strip(5, 'lbg-strip--side') + '<div class="lbg-side__logo">' + logo() + '</div>' +
            '<span class="lbg-eyebrow">' + esc(T.eyebrow || 'Gustometro') + '</span>' + title('p', 'lbg-side__title', false) + stepper() +
            '<div class="lbg-side__foot">' + shipLine() + '</div></aside>' +
          '<div class="lbg-main lbg-enter">' +
            '<div class="lbg-bar">' +
              '<button type="button" class="lbg-round" data-lbg-back aria-label="Domanda precedente">' + I.back + '</button>' +
              '<button type="button" class="lbg-backlink" data-lbg-back>' + I.back + 'Indietro</button>' +
              '<div class="lbg-prog"><small>' + (step + 1) + ' di ' + Q.length + '</small><div class="lbg-segs" aria-hidden="true">' + segs + '</div></div>' +
              exitBtn('lbg-round--m') +
            '</div>' +
            '<div class="lbg-qhead"><h2 class="lbg-q__title" tabindex="-1" data-lbg-focus>' + esc(q.t) + '</h2><p class="lbg-q__hint">' + esc(q.h) + '</p></div>' +
            '<div class="lbg-opts lbg-opts--' + q.lay + ' lbg-opts--n' + q.o.length + '" role="group" aria-label="' + esc(q.t) + '">' + opts + '</div>' +
            '<p class="lbg-q__foot">' + (step === Q.length - 1 ? 'Ultima domanda: dopo vedi il tuo caffè.' : '<span class="lbg-only-m">Tocca una risposta: passi da solo alla domanda dopo.</span><span class="lbg-only-d">Clicca una risposta oppure usa i tasti da 1 a ' + q.o.length + '.</span>') + '</p>' +
          '</div>' +
        '</section>'
      );
      app.querySelectorAll('[data-lbg-back]').forEach(function (b) { b.onclick = function () { if (busy) return; step--; render(true); }; });
      app.querySelectorAll('.lbg-opt, .lbg-tile').forEach(function (btn) { btn.onclick = function () { choose(+btn.dataset.i, btn); }; });
      if (focus) focusHeading();
    }

    function choose(i, btn) {
      if (busy || step < 0 || step >= Q.length) return;
      var q = Q[step];
      if (!btn) btn = app.querySelectorAll('.lbg-opt, .lbg-tile')[i];
      if (!btn) return;
      busy = true;
      ans[step] = i;
      app.querySelectorAll('.lbg-opt, .lbg-tile').forEach(function (x) { x.setAttribute('aria-pressed', x === btn); });
      pulse(btn);
      track('gustometro_step', { question: step + 1, key: q.k, answer: q.o[i].l });
      setTimeout(function () { busy = false; step++; render(true); }, reduced() ? 120 : ADVANCE_MS);
    }

    // tasti 1-n sulle domande (desktop)
    root.addEventListener('keydown', function (e) {
      if (step < 0 || step >= Q.length || e.altKey || e.ctrlKey || e.metaKey) return;
      var t = e.target && e.target.tagName;
      if (t === 'INPUT' || t === 'TEXTAREA' || t === 'SELECT') return;
      var n = parseInt(e.key, 10);
      if (n >= 1 && n <= Q[step].o.length) { e.preventDefault(); choose(n - 1); }
    });

    /* ----- risultato ----- */
    function showResult(save) {
      if (!blends.length) { paint('<p class="lbg-empty">Nessuna miscela disponibile per il Gustometro.</p>'); return; }
      var ranked = rank(blends, ans);
      if (save) saveState();
      draw({ ranked: ranked, u: userProfile(ans), G: GRINDS[ans[0]], C: CONSUMO[ans[5]], link: false });
    }
    function decafFor(ranked) {
      for (var i = 0; i < ranked.length; i++) if (ranked[i].b.decaf) return ranked[i].b.decaf;
      return null;
    }
    function ring(pct) {
      var c = 2 * Math.PI * 32, on = c * pct / 100;
      return '<div class="lbg-ring" role="img" aria-label="' + pct + '% di affinità"><svg viewBox="0 0 76 76" aria-hidden="true"><circle cx="38" cy="38" r="32" class="lbg-ring__bg"/><circle cx="38" cy="38" r="32" class="lbg-ring__fg" stroke-dasharray="' + on.toFixed(1) + ' ' + c.toFixed(1) + '"/></svg>' +
        '<span><b>' + pct + '%</b><small>affinità</small></span></div>';
    }

    // desktop: la descrizione nella colonna scura si accorcia finché tutto sta nella finestra
    function fitDesc() {
      var card = app.querySelector('.lbg-card'), d = card && card.querySelector('.lbg-desc');
      if (!d) return;
      var pEl = d.querySelector('p');
      d.style.display = ''; pEl.style.display = ''; pEl.style.webkitLineClamp = '';
      if (window.innerWidth < 750 || getComputedStyle(d).display === 'none') return;
      var lines = 7;
      while (card.scrollHeight > card.clientHeight + 1 && lines > 2) { lines--; pEl.style.webkitLineClamp = String(lines); }
      if (card.scrollHeight > card.clientHeight + 1) pEl.style.display = 'none';
      if (card.scrollHeight > card.clientHeight + 1) d.style.display = 'none';
    }
    function draw(ctx) {
      var G = ctx.G, C = ctx.C, ranked = ctx.ranked, cialde = G.k === 'cialde';
      var dec = (!cialde && !ctx.link) ? decafFor(ranked) : null;
      var useDecaf = !!(dec && decafOn);
      var decR = useDecaf ? score(dec, ans) : null;

      var pool = cialde ? ranked.filter(function (r) { return r.b.pods.length; }) : ranked;
      if (useDecaf) pool = [decR].concat(ranked);
      var shown = pool[0] || ranked[0];
      var purchase = null, pk = null;
      for (var i = 0; i < pool.length; i++) {
        var t = pick(pool[i].b, G, C);
        if (!t.soldout) { purchase = pool[i]; pk = t; break; }
      }
      var alt = ctx.link ? null : ranked.filter(function (r) {
        return r !== shown && r !== purchase && !((cialde || useDecaf) && r === ranked[0]);
      })[0];
      var b = shown.b;
      var pct = ctx.link ? null : shown.pct;

      /* profilo (barre) */
      var rows = [['c', 'Corpo'], ['d', 'Dolcezza'], ['a', 'Acidità'], ['p', 'Persistenza']].filter(function (d) { return b.v[d[0]] != null; }).map(function (d) {
        var v = Math.max(0, Math.min(5, Math.round(b.v[d[0]])));
        var uv = ctx.u && d[0] !== 'p' ? ctx.u[d[0]] : null;
        var mark = uv != null ? '<span class="lbg-you" style="left:' + ((uv - 0.5) / 5 * 100).toFixed(2) + '%"></span>' : '';
        return '<div class="lbg-row"><dt>' + d[1] + '</dt><dd class="lbg-row__bar" role="img" aria-label="' + d[1] + ': miscela ' + v + ' su 5' +
          (uv != null ? ', il tuo gusto ' + uv.toFixed(1).replace('.', ',') + ' su 5' : '') + '">' +
          [1, 2, 3, 4, 5].map(function (n) { return '<i class="' + (n <= v ? 'is-on' : '') + '"></i>'; }).join('') + mark + '</dd><dd class="lbg-row__v">' + v + '/5</dd></div>';
      }).join('');
      var idLabels = ['Origine', 'Tostatura', 'Note di gusto'];
      var idc = (D.showIdentity && !b.isDecaf) ? (b.idc || []).map(function (x, k) { return x ? '<span><small>' + idLabels[k] + '</small>' + esc(x) + '</span>' : ''; }).filter(Boolean).join('') : '';

      /* note */
      var notes = [];
      if (cialde && ranked[0] && ranked[0] !== shown) {
        notes.push('La tua miscela ideale è <a href="' + esc(ranked[0].b.p.url) + '"><b>' + esc(ranked[0].b.name) + '</b></a>' +
          (ctx.link ? '' : ' (' + ranked[0].pct + '%)') + ': oggi la trovi in grani e macinata.');
      }
      if (cialde && !pool.length) notes.push('Questa miscela non è ancora disponibile in cialde.');
      if (useDecaf) {
        var ideal = ranked[0];
        if (dec.base === ideal.b) notes.push('<b>' + esc(dec.name) + '</b> è la versione decaffeinata della tua miscela ideale, <b>' + esc(ideal.b.name) + '</b>.');
        else notes.push('La tua miscela ideale è <a href="' + esc(ideal.b.p.url) + '"><b>' + esc(ideal.b.name) + '</b></a> (' + ideal.pct + '%). Il nostro decaffeinato è <b>' + esc(dec.name) + '</b>, ' + decR.pct + '% di affinità con il tuo gusto.');
      }
      if (purchase && purchase !== shown) {
        notes.push('<b>' + esc(b.name) + '</b>' + (cialde ? ' in cialde' : '') + ' al momento non è disponibile. <a href="' + esc(b.p.url) + '">Avvisami quando torna</a>. Intanto ti proponiamo <b>' + esc(purchase.b.name) + '</b>' +
          (ctx.link ? '' : ' (' + purchase.pct + '%)') + ', la più vicina al tuo gusto dopo.');
      }
      if (purchase && pk.note) notes.push(esc(pk.note));
      if (!purchase && !(cialde && !pool.length)) notes.push(esc(b.name) + (cialde ? ' in cialde' : '') + ' al momento non è disponibile.');

      /* card */
      var cardImg = b.p.img, cardName = b.name, cardSub = b.sub;
      if (cialde && b.pods.length) {
        var cardPod = (purchase === shown && pk && pk.pod) ? pk.pod : (b.pods.filter(function (x) { return x.a; })[0] || b.pods[0]);
        cardImg = cardPod.img || b.p.img; cardName = b.name + ' in cialde'; cardSub = 'Cialde in carta ESE 44 mm';
      }

      /* scelta */
      var pickHtml = '', buyHtml = '';
      if (purchase) {
        var fmtMain, fmtSub, fIcon = I.bag, weeks = 0;
        if (cialde) {
          fIcon = I.pod;
          var isSmall = pk.pod === purchase.b.pods[0] && purchase.b.pods.length > 1;
          fmtMain = pk.pod.pz + ' cialde' + (pk.qty > 1 ? ' × ' + pk.qty : '');
          if (C.cpd > 0 && !isSmall) weeks = Math.round(pk.pod.pz * pk.qty / (C.cpd * 7));
          fmtSub = pk.qty > 1 ? (pk.pod.pz * pk.qty) + ' cialde' : (C.k === 'assaggio' || isSmall ? 'formato assaggio' : 'confezione');
          if (weeks) fmtSub = (pk.qty > 1 ? fmtSub + ', ' : '') + 'circa ' + weeks + ' settimane';
        } else {
          fmtMain = wLabel(pk.g);
          if (C.cpd > 0) weeks = Math.round(pk.g / (C.cpd * 7 * 7));
          fmtSub = pk.g === 250 ? 'formato assaggio' : (weeks ? 'circa ' + weeks + ' settimane' : (String(pk.v.f).split(' - ')[1] || '').replace(/\s+/g, ' ').trim());
        }
        pickHtml =
          '<div class="lbg-chips">' +
            '<div class="lbg-chip">' + G.i + '<span><b>' + esc(G.chip) + '</b><small>' + (cialde ? 'carta ESE 44 mm' : 'macinatura') + '</small></span></div>' +
            '<div class="lbg-chip">' + fIcon + '<span><b>' + esc(fmtMain) + '</b>' + (fmtSub ? '<small>' + esc(fmtSub) + '</small>' : '') + '</span></div>' +
          '</div>';
        buyHtml =
          '<div class="lbg-buy">' +
            '<div class="lbg-ship" data-lbg-ship><span class="lbg-ship__bar"><i style="width:0"></i></span><p></p></div>' +
            '<div class="lbg-buy__row"><div class="lbg-price"><small>Prezzo</small><strong>' + (pk.qty > 1 ? '<span>' + pk.qty + ' × ' + money(pk.price) + '</span> ' : '') + money(pk.price * pk.qty) + '</strong></div>' +
            '<button type="button" class="lbg-gold" data-lbg-atc>' + I.cart + 'Aggiungi al carrello</button></div>' +
            '<p class="lbg-toast" data-lbg-toast role="status"></p>' +
          '</div>';
      } else {
        buyHtml = '<div class="lbg-buy"><div class="lbg-buy__row"><a class="lbg-gold" href="' + esc(b.p.url) + '">' + I.bell + 'Avvisami quando torna</a></div></div>';
      }
      var decafHtml = dec ? '<button type="button" class="lbg-decaf" role="switch" aria-checked="' + useDecaf + '" data-lbg-decaf>' + I.moon +
        '<span><b>Lo preferisco decaffeinato</b><small>' + (useDecaf ? esc(dec.name) + ', stessa macinatura e formato' : 'Ti proponiamo ' + esc(dec.name)) + '</small></span><i aria-hidden="true"></i></button>' : '';

      var altHtml = alt ? '<a class="lbg-alt" href="' + esc(alt.b.p.url) + '">' + (alt.b.p.img ? '<img src="' + esc(alt.b.p.img) + '" alt="" width="56" height="56" loading="lazy">' : '<span class="lbg-alt__ph"></span>') +
        '<span class="lbg-alt__t"><small>Ti potrebbe piacere anche</small><b>' + esc(alt.b.name) + '</b></span><span class="lbg-alt__pct">' + alt.pct + '%</span></a>' : '';

      paint(
        '<section class="lbg-screen lbg-res">' +
          '<div class="lbg-bar lbg-bar--res">' +
            '<button type="button" class="lbg-round" data-lbg-again aria-label="Rifai il test">' + I.restart + '</button>' +
            '<span class="lbg-bar__title">Il tuo risultato</span>' + exitBtn() +
          '</div>' +
          '<div class="lbg-scroll">' +
            '<div class="lbg-card lbg-enter">' + strip(6, 'lbg-strip--card') +
              '<span class="lbg-eyebrow">Il tuo caffè è</span>' +
              '<div class="lbg-hero">' + (cardImg ? '<img src="' + esc(cardImg) + '" alt="' + esc(cardName) + '" width="220" height="220">' : '') +
                '<div><h2 class="lbg-hero__title" tabindex="-1" data-lbg-focus>' + esc(cardName) + '</h2>' + (cardSub ? '<p class="lbg-hero__sub">' + esc(cardSub) + '</p>' : '') + '</div></div>' +
              (b.desc ? '<div class="lbg-desc"><p>' + esc(b.desc) + '</p><a href="' + esc(b.p.url) + '">Leggi la scheda completa' + I.next + '</a></div>' : '') +
              '<div class="lbg-why">' + (pct != null ? ring(pct) : '') + '<p>' + esc(whyShort(b)) + '</p></div>' +
              '<button type="button" class="lbg-more" data-lbg-open>Vedi il profilo completo' + I.next + '</button>' +
            '</div>' +
            '<div class="lbg-panel">' +
              '<div class="lbg-sheet" data-lbg-sheet>' +
                '<div class="lbg-sheet__in" data-lbg-sheet-in>' +
                  '<span class="lbg-sheet__handle" aria-hidden="true"></span>' +
                  '<div class="lbg-profile">' +
                    '<div class="lbg-profile__head"><h3>Il tuo profilo</h3>' +
                      '<span class="lbg-legend"><span><i></i>' + (ctx.u ? 'miscela' : esc(b.name)) + '</span>' + (ctx.u ? '<span><i class="lbg-you-key"></i>il tuo gusto</span>' : '') + '</span>' +
                      '<button type="button" class="lbg-round lbg-sheet__x" data-lbg-close aria-label="Chiudi">' + I.close + '</button></div>' +
                    '<dl class="lbg-rows">' + rows + '</dl>' +
                    '<p class="lbg-profile__close">' + esc(WHY_CLOSE) + '</p>' +
                    (idc ? '<div class="lbg-id">' + idc + '</div>' : '') +
                  '</div>' +
                  '<div class="lbg-extra">' + altHtml + '<div class="lbg-mailslot" data-lbg-mailslot></div>' +
                    '<button type="button" class="lbg-again" data-lbg-again>Rifai il test</button></div>' +
                '</div>' +
              '</div>' +
              '<div class="lbg-pick"><h3>La tua scelta' + (purchase && purchase !== shown ? ': ' + esc(purchase.b.name) : '') + '</h3>' + pickHtml + decafHtml +
                (notes.length ? '<div class="lbg-notes">' + notes.map(function (n) { return '<p>' + n + '</p>'; }).join('') + '</div>' : '') + '</div>' +
              buyHtml +
            '</div>' +
          '</div>' +
        '</section>'
      );

      /* stato per carrello / email */
      var tagFormat = purchase ? (cialde ? 'cialde-' + pk.pod.pz : wTag(pk.g)) : (cialde ? 'cialde-' + (C.k === 'assaggio' ? 'assaggio' : 'grande') : wTag(C.g));
      var d = new Date();
      var riord = '';
      if (purchase) {
        var isTaste = cialde ? (pk.pod === purchase.b.pods[0] && purchase.b.pods.length > 1) : pk.g <= 250;
        if (isTaste) riord = 'assaggio';
        else {
          var cpd = C.cpd > 0 ? C.cpd : 1.5;
          var dur = cialde ? (pk.pod.pz * pk.qty) / (cpd * 7) : pk.g / (cpd * 49);
          var w = Math.round(dur) - 2;
          riord = w >= 12 ? '12' : w >= 10 ? '10' : '8';
        }
      }
      cur = {
        slug: b.slug, grind: G.k, format: tagFormat, consumo: C.k,
        attr: (purchase ? purchase.b.name : b.name) + (purchase && !ctx.link ? ' · ' + purchase.pct + '%' : ''),
        profilo: [(purchase ? purchase.b.slug : b.slug), G.k, tagFormat, C.k].join('|'),
        riordino: riord,
        tags: ['gustometro', 'gusto-' + b.slug, 'macinatura-' + G.k, 'formato-' + tagFormat, 'consumo-' + C.k,
          'caffeina-' + (b.isDecaf ? 'no' : 'si'),
          'gustometro-' + d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0')].join(', ')
      };
      if (!ctx.link && !ctx.silent) track('gustometro_result', { blend: b.name, affinity: pct, grind: G.chip, format: tagFormat, consumo: C.k, decaf: b.isDecaf });

      fitDesc();
      if (purchase) shipBar(pk.price * pk.qty);

      var atc = app.querySelector('[data-lbg-atc]');
      if (atc) atc.onclick = function () { pulse(atc); addToCart(atc, pk, purchase); };

      var dsw = app.querySelector('[data-lbg-decaf]');
      if (dsw) dsw.onclick = function () {
        pulse(dsw);
        decafOn = !decafOn;
        saveState();
        track('gustometro_decaf', { on: decafOn, blend: dec.name });
        setTimeout(function () {
          draw(Object.assign({}, ctx, { silent: true }));
          var again = app.querySelector('[data-lbg-decaf]');
          if (again) again.focus();
        }, reduced() ? 0 : 220);
      };

      /* pannello profilo (mobile) */
      var sheet = app.querySelector('[data-lbg-sheet]');
      var opener = app.querySelector('[data-lbg-open]');
      function openSheet() {
        sheet.classList.add('is-open');
        sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true'); sheet.setAttribute('aria-label', 'Il tuo profilo');
        var x = sheet.querySelector('[data-lbg-close]'); if (x) x.focus();
      }
      function closeSheet() {
        sheet.classList.remove('is-open');
        sheet.removeAttribute('role'); sheet.removeAttribute('aria-modal'); sheet.removeAttribute('aria-label');
        if (opener) opener.focus();
      }
      if (opener) opener.onclick = function () { pulse(opener); openSheet(); };
      sheet.querySelector('[data-lbg-close]').onclick = closeSheet;
      sheet.onclick = function (e) { if (e.target === sheet) closeSheet(); };
      sheet.onkeydown = function (e) { if (e.key === 'Escape' && sheet.classList.contains('is-open')) closeSheet(); };
      draw.openSheet = openSheet;

      /* email */
      if (mail) {
        var slot = app.querySelector('[data-lbg-mailslot]');
        slot.appendChild(mail);
        mail.hidden = false;
        var tagInput = mail.querySelector('[data-lbg-tags]');
        if (tagInput) tagInput.value = cur.tags;
        var form = mail.querySelector('form');
        if (form && !form.dataset.lbgBound) {
          form.dataset.lbgBound = '1';
          form.addEventListener('submit', function () {
            var s = lsGet() || {};
            s.pending = true; lsSet(s);
            track('gustometro_email', { tags: cur && cur.tags });
          });
        }
      }

      app.querySelectorAll('[data-lbg-again]').forEach(function (btn) {
        btn.onclick = function () {
          ans = [null, null, null, null, null, null];
          decafOn = false;
          if (mail) { mail.hidden = true; root.appendChild(mail); }
          try { if (location.search.indexOf('r=') > -1) history.replaceState(null, '', location.pathname); } catch (e) {}
          step = -1; render(true);
        };
      });
      if (!ctx.silent) focusHeading();
    }

    function shipBar(add) {
      var box = app.querySelector('[data-lbg-ship]');
      if (!box || !D.threshold) { if (box) box.remove(); return; }
      function paintShip(total) {
        var sum = total + add, left = D.threshold - sum;
        box.querySelector('i').style.width = Math.min(100, Math.round(sum / D.threshold * 100)) + '%';
        var inCart = total > 0 ? 'Con quello che hai già nel carrello (' + money(total) + ') ' : '';
        var msg;
        if (left > 0) msg = (inCart ? inCart + 'ti mancano' : (D.firstOrder ? 'Primo ordine: ti mancano' : 'Ti mancano')) +
          ' <b>' + money(left) + '</b> per la spedizione gratuita' + (D.firstOrder && inCart ? ' sul primo ordine' : '');
        else msg = inCart + '<b>' + (inCart ? '' : '') + (D.firstOrder ? (inCart ? 'spedizione gratuita sul tuo primo ordine' : 'Spedizione gratuita sul tuo primo ordine') : (inCart ? 'spedizione gratuita inclusa' : 'Spedizione gratuita inclusa')) + '</b>';
        box.querySelector('p').innerHTML = msg;
        box.classList.toggle('is-free', left <= 0);
      }
      paintShip(D.cartTotal || 0);
      fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); }).then(function (c) { paintShip(c.total_price || 0); }).catch(function () {});
    }

    function postJSON(url, body) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) {
          return r.json().then(function (j) {
            if (!r.ok || j.status) throw new Error(j.description || j.message || 'Errore');
            return j;
          });
        });
    }

    function addToCart(btn, pk, purchase) {
      var toast = app.querySelector('[data-lbg-toast]');
      var R = window.routes || {};
      var drawer = document.querySelector('cart-drawer');
      btn.disabled = true; btn.classList.add('is-loading'); toast.textContent = '';
      postJSON((R.cart_add_url || '/cart/add') + '.js', { items: [{ id: pk.id, quantity: pk.qty }] })
        .then(function () {
          var body = { attributes: { gustometro: cur.attr, gustometro_profilo: cur.profilo, gustometro_riordino: cur.riordino } };
          if (drawer && typeof drawer.getSectionsToRender === 'function') {
            body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
            body.sections_url = location.pathname;
          }
          return postJSON((R.cart_update_url || '/cart/update') + '.js', body);
        })
        .then(function (cart) {
          track('gustometro_add_to_cart', { variant_id: pk.id, quantity: pk.qty, price: pk.price / 100, value: pk.price * pk.qty / 100, currency: D.currency, blend: purchase.b.name });
          try { if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'gustometro', cartData: cart }); } catch (e) {}
          if (drawer && typeof drawer.renderContents === 'function' && cart.sections) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(cart);
            btn.disabled = false; btn.classList.remove('is-loading');
            toast.textContent = 'Aggiunto al carrello.';
          } else {
            window.location.href = R.cart_url || '/cart';
          }
        })
        .catch(function (e) {
          btn.disabled = false; btn.classList.remove('is-loading');
          toast.textContent = (e && e.message && e.message !== 'Errore') ? e.message : 'Non siamo riusciti ad aggiungerlo al carrello. Riprova.';
        });
    }

    /* ----- riapertura da link (?r=&g=&f=&c=) ----- */
    function fromLink() {
      var q = new URLSearchParams(location.search);
      var r = slug(q.get('r') || ''), g = slug(q.get('g') || ''), f = slug(q.get('f') || ''), c = slug(q.get('c') || '');
      if (!r || !g) return false;
      var all = blends.concat(blends.map(function (b) { return b.decaf; }).filter(Boolean));
      var target = all.filter(function (b) { return b.slug === r || b.p.handle === r; })[0];
      var gi = GRINDS.map(function (x) { return x.k; }).indexOf(g);
      if (!target || gi < 0) return false;
      var ci = CONSUMO.map(function (x) { return x.k; }).indexOf(c);
      if (ci < 0) {
        var byF = { '250g': 3, '1kg': 0, '2kg': 1, '4kg': 2 };
        var pm = f.match(/^cialde-(\d+)$/);
        if (pm) ci = (+pm[1] < 150) ? 3 : 0;
        else ci = byF[f] != null ? byF[f] : 0;
      }
      var saved = lsGet();
      if (saved && validAns(saved.a) && saved.a[0] === gi) {
        var rk = rank(blends, saved.a);
        var top = gi === 4 ? rk.filter(function (x) { return x.b.pods.length; })[0] : rk[0];
        var topDecaf = saved.d && gi !== 4 ? decafFor(rk) : null;
        var hit = target.isDecaf ? (topDecaf === target) : (!saved.d && top && top.b === target);
        if (hit) { ans = saved.a.slice(); decafOn = !!saved.d; showResult(false); return true; }
      }
      var ranked = [target].concat(blends.filter(function (b) { return b !== target; })).map(function (b) { return { b: b, pct: null }; });
      draw({ ranked: ranked, u: null, G: GRINDS[gi], C: CONSUMO[ci], link: true });
      return true;
    }

    /* ----- pannello di controllo (solo editor del tema) ----- */
    function diagnostics() {
      if (!D.design) return '';
      return '<div class="lbg-diag"><b>Controllo dati (visibile solo nell\'editor) · codice v4.8</b>' +
        '<p>Logo: ' + (D.logo ? 'immagine scelta' + (D.logoLight ? ', resa chiara' : '') : 'nessuna immagine, uso la scritta LARABICO') + ' · Uscita (X): ' + esc(D.exitUrl || '/') + '</p>' +
        '<table><thead><tr><th>Prodotto</th><th>Stato</th><th>Nome / tag</th><th>C·D·A·P</th><th>Varianti</th><th>250 g</th><th>Cialde</th><th>Decaffeinato</th><th>Carta d\'identità</th></tr></thead><tbody>' +
        report.map(function (r) {
          if (!r.ok) return '<tr class="is-ko"><td>' + esc(r.title) + '</td><td colspan="8">Esclusa: ' + esc(r.why) + '</td></tr>';
          var b = r.b;
          var tv = b.taste ? b.taste.variants.filter(function (v) { return v.g === 250; }).length : 0;
          return '<tr><td>' + esc(r.title) + '</td><td>OK</td><td>' + esc(b.name) + '<br><code>gusto-' + esc(b.slug) + '</code></td><td>' +
            [b.v.c, b.v.d, b.v.a, b.v.p == null ? '–' : b.v.p].join(' · ') + '</td><td>' +
            b.p.variants.length + ' (' + b.p.variants.filter(function (v) { return v.a; }).length + ' disp.)<br><small>' +
            uniq(b.p.variants.map(function (v) { return wLabel(v.g); })).join(', ') + '<br>' + uniq(b.p.variants.map(function (v) { return v.m; })).join(', ') + '</small>' + stockWarn(b.p) + (b.taste ? stockWarn(b.taste) : '') + '</td><td>' +
            (b.taste ? esc(b.taste.handle) + '<br><small>' + tv + ' varianti da 250 g</small>' : '—') + '</td><td>' +
            podsDiag(b) + '</td><td>' + decafDiag(b, r) + '</td><td>' +
            (b.idc || []).map(function (x) { return esc(x || '—'); }).join('<br>') + '</td></tr>';
        }).join('') + '</tbody></table></div>';
    }
    function stockWarn(P) {
      var byG = {};
      P.variants.forEach(function (v) { (byG[v.g] = byG[v.g] || []).push(v.a); });
      var bad = Object.keys(byG).filter(function (g) { return byG[g].indexOf(true) > -1 && byG[g].indexOf(false) > -1; });
      return bad.length ? '<br><b class="lbg-diag__warn">Attenzione: ' + esc(P.handle) + ', ' + bad.map(function (g) { return wLabel(+g); }).join(', ') +
        ' disponibile solo in alcune macinature. Controlla scorte / "Continua a vendere".</b>' : '';
    }
    function podsDiag(b) {
      if (!b.podsType && !b.podsRaw.length) return '<small>metafield <code>custom.gustometro_cialde</code> non trovato su questo prodotto</small>';
      var out = b.pods.map(function (p, i) {
        return p.pz + ' pz' + (p.a ? '' : ' (esaurito)') + (b.pods.length > 1 ? (i === 0 ? ' · assaggio' : (i === b.pods.length - 1 ? ' · consumo' : '')) : '');
      }).join('<br>');
      var warn = [];
      b.podsRaw.forEach(function (x) {
        if (!x) warn.push('Un prodotto collegato non è leggibile: pubblicalo sul canale Negozio online.');
        else if (!podsCount(x.title, x.handle)) warn.push(esc(x.title) + ': numero di cialde non trovato (serve "50pz" o "50 cialde" nel titolo).');
      });
      if (!b.podsRaw.length) warn.push('Metafield compilato (' + esc(b.podsType) + ') ma nessun prodotto letto: controlla che le cialde siano pubblicate sul canale Negozio online.');
      return (out || '<small>nessuna confezione valida</small>') + warn.map(function (w) { return '<br><b class="lbg-diag__warn">' + w + '</b>'; }).join('');
    }
    function decafDiag(b, r) {
      if (r.decafWhy) return '<b class="lbg-diag__warn">' + esc(r.decafWhy) + '</b>';
      if (!b.decaf) return '—';
      var x = b.decaf;
      return esc(x.name) + '<br><code>gusto-' + esc(x.slug) + '</code><br><small>' + esc(x.p.handle) + ' · ' + x.p.variants.length + ' varianti · ' +
        [x.v.c, x.v.d, x.v.a, x.v.p == null ? '–' : x.v.p].join(' · ') + '</small>' +
        (x.ownValues ? '' : '<br><b class="lbg-diag__warn">coffee_values mancante sul decaffeinato: uso i valori di ' + esc(b.name) + '.</b>') + stockWarn(x.p);
    }
    function uniq(a) { return a.filter(function (x, i) { return x && a.indexOf(x) === i; }); }

    /* ----- avvio ----- */
    var posted = mail && (mail.querySelector('[data-lbg-posted]') || mail.querySelector('[data-lbg-error]'));
    var savedStart = lsGet();
    if (posted && savedStart && validAns(savedStart.a)) {
      ans = savedStart.a.slice();
      decafOn = !!savedStart.d;
      if (savedStart.pending) { delete savedStart.pending; lsSet(savedStart); }
      showResult(false);
      if (window.innerWidth < 750 && draw.openSheet) draw.openSheet();
      setTimeout(function () { mail.scrollIntoView({ behavior: 'auto', block: 'center' }); }, 60);
      return;
    }
    if (fromLink()) return;
    render(false);
  }

  function boot() {
    document.querySelectorAll('[data-lbg]').forEach(function (el) {
      if (el.dataset.lbgReady) return;
      el.dataset.lbgReady = '1';
      Gustometro(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
